import PropTypes from 'prop-types'
import React from 'react'
import { theme } from '../../global/_theme'
import './styles.scss'

const AsideSection = ({ title, children }) => (
  <div className="aside-section">
    <div className="aside-section__title" color={theme.neutral.white}>
      {title}
    </div>
    <ul className="aside-section__list">
      {children.length > 1 ? (
        children.map((child, index) => (
          <li className="aside-section__list__item" key={index}>
            {child}
          </li>
        ))
      ) : (
        <li className="aside-section__list__item">{children}</li>
      )}
    </ul>
  </div>
)

AsideSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
}

export default AsideSection
